import React from "react"
import cn from "classnames"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// While busy the button keeps its colors and focus (a disabled button loses
// both) and announces aria-busy; repeat clicks are swallowed so a slow
// Lambda can't receive the same submission twice.
const SubmitButton = ({ busy, children = "Submit", busyText = "Sending…", className, ...rest }) => (
    <button
        type="submit"
        className={cn(styles.submit, className)}
        aria-busy={busy ? "true" : undefined}
        onClick={busy ? e => e.preventDefault() : undefined}
        {...rest}
    >
        {busy && <span className={styles.spinner} aria-hidden="true" />}
        {busy ? busyText : children}
    </button>
)

export default SubmitButton
